module.exports = __webpack_public_path__ + "assets/img/menu-library.27dad580.svg";